import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routerPush = Router.prototype.push;
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(error => error)
};

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('./components/main-layout.vue'),
      redirect: '/alarm',
      children: [
        {
          path: '/alarm',
          name: 'my_alarm',
          component: () => import('./views/alarm/index.vue')
        },
        {
          path: '/alarm/:id',
          name: 'alarm_detail',
          component: () => import('./views/alarm/detail.vue'),
          beforeEnter: pc_mobile_switch
        },
        {
          path: '/manage',
          name: 'my_alarm_manage',
          component: () => import('./views/manage/index.vue')
        },
        {
          path: '/manage/:id',
          name: 'manage_detail',
          component: () => import('./views/manage/detail.vue'),
          beforeEnter: pc_mobile_switch
        },
        {
          path: '/statement',
          name: 'my_statement',
          component: () => import('./views/statement/index.vue')
        },
        {
          path: '/statement/:id/:pageId',
          name: 'statement_detail',
          component: () => import('./views/statement/detail.vue')
        },
        {
          path: '/file_alert_index',
          name: 'file_alert_index',
          component: () => import('./views/file_trace/pc/alert_index.vue'),
          beforeEnter: pc_mobile_switch
        },
        {
          path: '/file_alert_detail',
          name: 'file_alert_detail',
          component: () => import('./views/file_trace/pc/alert_detail.vue'),
          beforeEnter: pc_mobile_switch
        },
      ]
    },
    {
      path: '/complaint',
      name: 'complaint',
      component: () => import('./views/complaint/detail.vue')
    },
    {
      path: '/logout_detail/:id',
      name: 'logout_detail',
      component: () => import('./views/alarm/logout/logout_detail.vue'),
      beforeEnter: pc_mobile_switch
    },
    {
      path: '/logout_index',
      name: 'logout_index',
      component: () => import('./views/alarm/logout/logout_index.vue')
    },
    {
      path: '/intercept',
      name: 'intercept',
      component: () => import('./views/intercept/intercept.vue')
    },
    {
      path: '/sso_complaint',
      name: 'sso_complaint',
      component: () => import('./views/complaint/sso_complaint.vue')
    },
    {
      path: '/mobile',
      component: () => import('./components/router-view.vue'),
      redirect: {name: 'mobile_file_alert_index'},
      children: [
        {
          path: 'alert_index',
          name: 'mobile_file_alert_index',
          component: () => import('./views/file_trace/mobile/alert_index.vue'),
          beforeEnter: pc_mobile_switch
        },
        {
          path: 'alert_detail',
          name: 'mobile_file_alert_detail',
          component: () => import('./views/file_trace/mobile/alert_detail.vue'),
          beforeEnter: pc_mobile_switch
        },
      ]
    },
    {
      path: '/mobile_alarm_detail/:id',
      name: 'mobile_alarm_detail',
      component: () => import('./views/alarm/mobile_detail.vue'),
      beforeEnter: pc_mobile_switch
    },
    {
      path: '/mobile_logout_detail/:id',
      name: 'mobile_logout_detail',
      component: () => import('./views/alarm/mobile_detail.vue'),
      beforeEnter: pc_mobile_switch
    },
    {
      path: '/mobile_manage_detail/:id',
      name: 'mobile_manage_detail',
      component: () => import('./views/manage/mobile_detail.vue'),
      beforeEnter: pc_mobile_switch
    },
    {
      name: '404',
      path: '/404',
      component: () => import('./views/404.vue')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
});

function pc_mobile_switch(to, _from, next) {
  // 判断是否是手机端
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  let isMobile = (flag !== null);
  // 获取下一个页面地址
  let nextName = to.name;
  let path = to.path;
  if (isMobile) {
    // 跳转到手机端页面
    if (nextName.indexOf("mobile_") !== 0) {
      nextName = "mobile_" + nextName;
    }
  } else {
    // 跳转到手机端页面
    if (nextName.indexOf("mobile_") === 0) {
      nextName = nextName.substr(7);
    }
  }
  if (nextName === to.name) {
    next();
  } else {
    if (to.path.indexOf('/alarm/') === 0) {
      path = '/mobile_alarm_detail/' + to.path.substr(7);
      next({path: path});
      return;
    } else if (to.path.indexOf('/manage/') === 0) {
      path = '/mobile_manage_detail/' + to.path.substr(8);
      next({path: path});
      return;
    } else if (to.path.indexOf('/logout_detail/') === 0) {
      path = '/mobile_logout_detail/' + to.path.substr(15);
      next({path: path});
      return;
    } else if (to.path.indexOf('/mobile_alarm_detail/') === 0) {
      path = '/alarm/' + to.path.substr(21);
      next({path: path});
    } else if (to.path.indexOf('/mobile_manage_detail/') === 0) {
      path = '/manage/' + to.path.substr(22);
      next({path: path});
    } else if (to.path.indexOf('/mobile_logout_detail/') === 0) {
      path = '/logout_detail/' + to.path.substr(22);
      next({path: path});
    } else {
      let redirect = {name: nextName, query: to.query, params: to.params};
      next(redirect);
    }
  }

}
